import Swiper from "swiper";
import { Grid, Pagination } from "swiper/modules";

$(function () {
	let majorSlider = new Swiper(".major-slider .swiper", {
		modules: [Grid, Pagination],
		slidesPerView: 1,
		spaceBetween: 20,
		pagination: {
			el: ".major-slider .swiper-pagination",
			clickable: true,
			dynamicBullets: true,
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				grid: {
					rows: 2,
				},
			},
			1024: {
				slidesPerView: 3,
				grid: {
					rows: 3,
					fill: "row",
				},
			},
		},
	});
});
